export const environment = {
   useEmulators: false,
   localIpAddress: 'localhost',
   /** Super-admin console (kottra-admin repo); the old /admin route redirects here. */
   adminAppUrl: 'https://admin.kottra.com',
   firebase: {
      apiKey: 'AIzaSyCIzxUMPsOJZo_F7Hx3LsgUltaUz3rhXL8',
      authDomain: 'kottra-staging.web.app',
      projectId: 'kottra-pos-d7e02',
      storageBucket: 'kottra-as1',
      messagingSenderId: '421403764828',
      appId: '1:421403764828:web:8252a91317a50122509e99',
      measurementId: 'G-CHP33XZN7Q',
   },
   appCheck: {
      siteKey: '6LcpZPEsAAAAABFm6ppKMCXwURCHYrBMmg3Qzhzm',
      useDebugProvider: true,
   },

   /**
    * Public digital menu, a separate app on its own Hosting site. The menu
    * editor's live preview iframe loads `${menuBaseUrl}/<store>?preview=1`.
    * Staging shares the prod Firebase
    * project, so the prod menu shows the same data.
    */
   menuBaseUrl: 'https://menu.kottra.com',

   /**
    * Public-menu app boot tuning. `skipAppCheck`: App Check *enforcement* is
    * off for Firestore (verified 2026-09-30 — a token-less REST read of
    * `stores` returns 200), so the menu skips the ~350 KB reCAPTCHA script
    * that otherwise gated the first read by ~1 s. If enforcement is ever
    * turned on, set this back to false first or the menu's reads will be
    * rejected.
    */
   publicMenuFastBoot: {
      skipAppCheck: true,
   },
};
